import cssUtil from 'gw-portals-util-js/CssUtil';
import _ from 'lodash';
import templateStr from 'text!./gateway-report-producer-commission-to-date-directive.html';
import styles from './gatewayReportProducerCommissionToDate-hashed.scss';

const hashedTemplate = cssUtil.hashTemplate(templateStr, styles);

/**
 * FaqDirective
 * @example <gw-report-producer-commission-to-date producer-code='1001-9874'></gw-report-producer-commission>
 */
class GatewayReportProducerCommissionToDateDirective {

    /**
     * Define directive's attributes
     */
    constructor() {
        /**
         * @type {String}
         */
        this.restrict = 'E';

        /**
         * @type {String}
         */
        this.template = hashedTemplate;

        this.scope = {
            producerCode: '@'
        };

        /**
         * @type {Function}
         */
        this.controller = controller;
    }
}

const controller = ($scope, INFOCENTER_GPA_REPORT_API_ENDPOINTS, $http, ModalService) => {

    const init = () => {
        loadReport();
    };

    $scope.createReportLoadingPromise = (targetURL) => {
        return $http({
            method: 'GET',
            url: targetURL
        });
    };

    const loadReport = () => {
        const reportAPIEndpointURL = getAPIEndPoint();
        $scope.reportLoadingPromise = $scope.createReportLoadingPromise(reportAPIEndpointURL);
        $scope.reportLoadingPromise
            .then(
                (data) => {
                    $scope.reportData = data.data.document.pages;
                },
                () => {
                    ModalService.showError('gateway.views.reports.commissions.Error', 'gateway.views.reports.commissions.Could not retrieve report');
                }
            );
    };

    const processReportData = () => {
        $scope.dataReportColumnTitles = [];
        $scope.dataReportColumnData = [];
        $scope.ytdEarned = {
            'amount': 0
        };
        $scope.mtdEarned = {
            'amount': 0
        };
        $scope.ytdWriteoff = {
            'amount': 0
        };
        $scope.mtdWriteoff = {
            'amount': 0
        };
        _.each($scope.reportData, (eachPage) => {
            _.each(eachPage.page.body.item, (eachItem) => {
                _.each(eachItem.lst.colTitle, (title) => {
                    _.each(title.item, (eachTitleItem) => {
                        $scope.dataReportColumnTitles.push(eachTitleItem.txt.val);
                    });
                });

                _.each(eachItem.lst.group.row, (dataRow) => {
                    $scope.mtdEarned.amount += parseFloat(dataRow.cell[10].item[0].txt.val);
                    $scope.ytdEarned.amount += parseFloat(dataRow.cell[11].item[0].txt.val);
                    $scope.mtdWriteoff.amount += parseFloat(dataRow.cell[12].item[0].txt.val);
                    $scope.ytdWriteoff.amount += parseFloat(dataRow.cell[13].item[0].txt.val);
                    $scope.dataReportColumnData.push(dataRow);
                });
            });
        });
        $scope.mtdTotalCommission = {
            'amount': $scope.mtdEarned.amount - $scope.mtdWriteoff.amount
        };
        $scope.ytdTotalCommission = {
            'amount': $scope.ytdEarned.amount - $scope.ytdWriteoff.amount
        };
    };

    const getAPIEndPoint = () => {
        if (!_.isEmpty($scope.producerCode) && $scope.producerCode !== 'all') {
            return `${INFOCENTER_GPA_REPORT_API_ENDPOINTS.commissions_rest_api}&p_ProducerCode=${$scope.producerCode}`;
        }
        return INFOCENTER_GPA_REPORT_API_ENDPOINTS.commissions_rest_api;
    };

    $scope.$watch('producerCode', () => {
        loadReport();
    });

    $scope.$watch('reportData', () => {
        try {
            processReportData();
        } catch (err) {
            ModalService.showError('gateway.views.reports.commissions.Error', 'gateway.views.reports.commissions.Could not retrieve report');
        }
    });

    $scope.dataReportColumnTitles = [];
    $scope.dataReportColumnData = [];
    init();
};

controller.$inject = ['$scope', 'INFOCENTER_GPA_REPORT_API_ENDPOINTS', '$http', 'ModalService'];

export default GatewayReportProducerCommissionToDateDirective;